/**
 * OrbitalRing
 *
 * 점선 원형 궤도 링 컴포넌트 (SVG)
 * - 점선 스타일의 원형 궤도
 * - 회전 애니메이션 없음 (고정 배경)
 */

import React from 'react';
import { motion } from 'framer-motion';

/**
 * OrbitalRing
 *
 * @param {number} radius - 궤도 반지름
 * @param {object} center - 중심점 { x, y }
 * @param {string} strokeColor - 선 색상 (기본: currentColor)
 * @param {number} strokeWidth - 선 두께 (기본: 1)
 * @param {string} strokeDasharray - 점선 패턴 (기본: "4 6")
 * @param {number} opacity - 투명도 (기본: 0.3)
 * @param {boolean} animated - 페이드 인 애니메이션 여부
 * @param {number} animationDelay - 애니메이션 지연 시간
 */
const OrbitalRing = ({
  radius,
  center,
  strokeColor = 'currentColor',
  strokeWidth = 1,
  strokeDasharray = '4 6',
  opacity = 0.3,
  animated = true,
  animationDelay = 0,
}) => {
  const circleProps = {
    cx: center.x,
    cy: center.y,
    r: radius,
    fill: 'none',
    stroke: strokeColor,
    strokeWidth,
    strokeDasharray,
    opacity,
  };

  if (animated) {
    return (
      <motion.circle
        {...circleProps}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity, scale: 1 }}
        transition={{
          duration: 0.8,
          delay: animationDelay,
          ease: 'easeOut',
        }}
      />
    );
  }

  return <circle {...circleProps} />;
};

export default OrbitalRing;
